export const Tasks = {
    canReadProfile: 1,
    canEditProfile: 2,
    canDeleteProfile: 3,
    canAddProfile: 4,
    canReadTest: 5,
    canEditTest: 6,
    canDeleteTest: 7,
    canAddTest: 8,
    canNotify: 9,
    canShareTest: 10,
    canViewUser: 11,
    canEditUser: 12,
    canDeleteUser: 13,
    canAddUser: 14,
    canViewNotificationTemplate: 15,
    canEditNotificationTemplate: 16,
    canDeleteNotificationTemplate: 17,
    canAddNotificationTemplate: 18,
    canViewSubOrganization: 19,
    canEditSubOrganization: 20,
    canDeleteSubOrganization: 21,
    canAddSubOrganization: 22,
    shouldReadMetaInfo: 23,
    hasAllOrgs: 24,
    canViewTest: 25,
    canUploadProfiles: 26,
    isNoOrg: 27,
    canViewHealthData: 28,
    isFocusUser: 29,
    showOnlySelOrg: 30,
    canViewEmployee: 31,
    canViewReports: 32,
    canViewShareAudit: 33,
    canViewCustomer: 34,
    canViewTestReports: 35,
};

// const RoleUser = [
//     Tasks.canReadProfile,
//     Tasks.canEditProfile,
//     Tasks.canDeleteProfile,
//     Tasks.canAddProfile,
//     Tasks.canReadTest,
//     Tasks.canEditTest,
//     Tasks.canDeleteTest,
//     Tasks.canAddTest,
//     Tasks.canNotify,
//     Tasks.canShareTest,
//     Tasks.shouldReadMetaInfo
// ];

const RoleUser = [ // super user roles
    Tasks.canReadProfile,
    Tasks.canEditProfile,
    Tasks.canDeleteProfile,
    Tasks.canAddProfile,
    Tasks.canReadTest,
    Tasks.canEditTest,
    Tasks.canDeleteTest,
    Tasks.canAddTest,
    Tasks.canNotify,
    Tasks.canShareTest,
    Tasks.canViewTest,
    Tasks.canUploadProfiles,
    Tasks.canViewHealthData

];

const RoleOrganizationAdmin = [
    Tasks.canReadProfile,
    Tasks.canEditProfile,
    Tasks.canDeleteProfile,
    Tasks.canAddProfile,
    Tasks.canReadTest,
    Tasks.canEditTest,
    Tasks.canDeleteTest,
    Tasks.canAddTest,
    Tasks.canNotify,
    Tasks.canShareTest,
    Tasks.canViewUser,
    Tasks.canViewTestReports,
    Tasks.canEditUser,
    Tasks.canDeleteUser,
    Tasks.canAddUser,
    Tasks.canViewNotificationTemplate,
    Tasks.canEditNotificationTemplate,
    Tasks.canDeleteNotificationTemplate,
    Tasks.canAddNotificationTemplate,
    Tasks.canViewSubOrganization,
    Tasks.canEditSubOrganization,
    Tasks.canDeleteSubOrganization,
    Tasks.canAddSubOrganization,
    Tasks.hasAllOrgs,
    Tasks.canViewTest,
    Tasks.canUploadProfiles,
    Tasks.canViewHealthData
];

const RoleCustomerSupportSurpervisor = [
    Tasks.canReadProfile,
    Tasks.canEditProfile,
    Tasks.canDeleteProfile,
    Tasks.canAddProfile,
    Tasks.canReadTest,
    Tasks.canEditTest,
    Tasks.canDeleteTest,
    Tasks.canAddTest,
    Tasks.canNotify,
    Tasks.canShareTest,
    Tasks.canViewUser,
    Tasks.canViewTestReports,
    Tasks.canEditUser,
    Tasks.canDeleteUser,
    Tasks.canAddUser,
    Tasks.canViewNotificationTemplate,
    Tasks.canEditNotificationTemplate,
    Tasks.canDeleteNotificationTemplate,
    Tasks.canAddNotificationTemplate,
    Tasks.canViewSubOrganization,
    Tasks.canEditSubOrganization,
    Tasks.canDeleteSubOrganization,
    Tasks.canAddSubOrganization,
    Tasks.hasAllOrgs,
    Tasks.canViewTest,
    Tasks.canUploadProfiles,
    Tasks.isNoOrg,
    Tasks.canViewHealthData,
    Tasks.isFocusUser,
];

// const RoleCustomerSupport = [ // super user roles
//     Tasks.canReadProfile,
//     Tasks.canReadTest,
//     Tasks.isNoOrg,
//     Tasks.isFocusUser,
//     Tasks.showOnlySelOrg

// ];

const RoleFocusManager = [
    Tasks.canReadProfile,
    Tasks.canEditProfile,
    Tasks.canDeleteProfile,
    Tasks.canAddProfile,
    Tasks.canReadTest,
    Tasks.canEditTest,
    Tasks.canDeleteTest,
    Tasks.canAddTest,
    Tasks.canNotify,
    Tasks.canShareTest,
    Tasks.canViewUser,
    Tasks.canViewTestReports,
    Tasks.canEditUser,
    Tasks.canDeleteUser,
    Tasks.canAddUser,
    Tasks.canViewNotificationTemplate,
    Tasks.canEditNotificationTemplate,
    Tasks.canDeleteNotificationTemplate,
    Tasks.canAddNotificationTemplate,
    Tasks.canViewSubOrganization,
    Tasks.canEditSubOrganization,
    Tasks.canDeleteSubOrganization,
    Tasks.canAddSubOrganization,
    Tasks.hasAllOrgs,
    Tasks.canViewTest,
    Tasks.canUploadProfiles,
    Tasks.canViewHealthData,
    Tasks.isFocusUser,
    Tasks.canViewEmployee,
    Tasks.canViewReports,
    Tasks.isNoOrg,
    Tasks.canViewCustomer
];

const RoleFocusSuperAdmin = [
    Tasks.canReadProfile,
    Tasks.canEditProfile,
    Tasks.canDeleteProfile,
    Tasks.canAddProfile,
    Tasks.canReadTest,
    Tasks.canEditTest,
    Tasks.canDeleteTest,
    Tasks.canAddTest,
    Tasks.canNotify,
    Tasks.canShareTest,
    Tasks.canViewUser,
    Tasks.canViewTestReports,
    Tasks.canEditUser,
    Tasks.canDeleteUser,
    Tasks.canAddUser,
    Tasks.canViewNotificationTemplate,
    Tasks.canEditNotificationTemplate,
    Tasks.canDeleteNotificationTemplate,
    Tasks.canAddNotificationTemplate,
    Tasks.canViewSubOrganization,
    Tasks.canEditSubOrganization,
    Tasks.canDeleteSubOrganization,
    Tasks.canAddSubOrganization,
    Tasks.hasAllOrgs,
    Tasks.canViewTest,
    Tasks.canUploadProfiles,
    Tasks.canViewHealthData,
    Tasks.isFocusUser,
    Tasks.canViewEmployee,
    Tasks.canViewReports,
    Tasks.canViewShareAudit,
    Tasks.isNoOrg,
    Tasks.canViewCustomer
];

const RoleFocusAdmin = [
    Tasks.canReadProfile,
    Tasks.canEditProfile,
    Tasks.canDeleteProfile,
    Tasks.canAddProfile,
    Tasks.canReadTest,
    Tasks.canEditTest,
    Tasks.canDeleteTest,
    Tasks.canAddTest,
    Tasks.canNotify,
    Tasks.canShareTest,
    Tasks.canViewUser,
    Tasks.canViewTestReports,
    Tasks.canEditUser,
    Tasks.canDeleteUser,
    Tasks.canAddUser,
    Tasks.canViewNotificationTemplate,
    Tasks.canEditNotificationTemplate,
    Tasks.canDeleteNotificationTemplate,
    Tasks.canAddNotificationTemplate,
    Tasks.canViewSubOrganization,
    Tasks.canEditSubOrganization,
    Tasks.canDeleteSubOrganization,
    Tasks.canAddSubOrganization,
    Tasks.hasAllOrgs,
    Tasks.canViewTest,
    Tasks.canUploadProfiles,
    Tasks.canViewHealthData,
    Tasks.isFocusUser,
    Tasks.canViewEmployee,
    Tasks.isNoOrg,
    Tasks.canViewCustomer
];

const ROLES = {
    FOCUS_SUPER_ADMIN: 1,
    FOCUS_ADMIN: 2,
    CUSTOMER_SUPPORT_SUPERVISOR: 3,
    // CUSTOMER_SUPPORT: 4,
    FOCUS_MANAGER: 5,
    ORGANIZATION_ADMIN: 6,    
    USER: 7, // super user
    // USER: 8
};

const USER_ROLES = {
    ORGANIZATION_ADMIN: 6,    
    USER: 7, // super user
};

export default class Authorization {

    public static getRoleName(roleid: any) {
        let rolename: string = '';
        Object.keys(ROLES).forEach( (value: any, index: any) => {
            if (ROLES[value] === roleid) {
                rolename = value;
            }
        });
        return rolename;
    }

    public static canPerformTask( roleid: any, task: any ) {
        console.log('canPerformTask roleid', roleid);
        switch ( roleid ) {

            case ROLES.USER: return this.canUserPerformTask( task );
            // case ROLES.SUPER_USER: return this.canSuperUserPerformTask( task );
            case ROLES.ORGANIZATION_ADMIN: return this.canOrganizationAdminPerformTask( task );
            // case ROLES.CUSTOMER_SUPPORT: return this.canCustomerSupportPerformTask( task );
            case ROLES.CUSTOMER_SUPPORT_SUPERVISOR: 
                        return this.canCustomerSupportSurpervisorPerformTask( task );
            case ROLES.FOCUS_ADMIN: 
                return this.canFocusAdminPerformTask( task );
            case ROLES.FOCUS_MANAGER: 
                return this.canFocusManagerPerformTask( task );
            case ROLES.FOCUS_SUPER_ADMIN: 
                return this.canFocusSuperAdminPerformTask( task );
            default: return false;
        }
    }

    public static getTasks() {
        return Tasks;
    }

    public static getRoles() {
        return ROLES;
    }
    
    public static getUserRoles() {
        return USER_ROLES;
    }
    
    public static getRolesByRole(roleid: any) {
        switch ( roleid ) {
            // case ROLES.FOCUS_ADMIN: return [ ROLES.CUSTOMER_SUPPORT, ROLES.CUSTOMER_SUPPORT_SUPERVISOR ];
            case ROLES.FOCUS_ADMIN: return [ ROLES.CUSTOMER_SUPPORT_SUPERVISOR ];
            // case ROLES.FOCUS_MANAGER: return [ROLES.CUSTOMER_SUPPORT, 
            //         ROLES.CUSTOMER_SUPPORT_SUPERVISOR, ROLES.FOCUS_ADMIN];
            case ROLES.FOCUS_MANAGER: return [ROLES.CUSTOMER_SUPPORT_SUPERVISOR, ROLES.FOCUS_ADMIN];
            // case ROLES.FOCUS_SUPER_ADMIN: return [ROLES.CUSTOMER_SUPPORT, ROLES.CUSTOMER_SUPPORT_SUPERVISOR,
            //         ROLES.FOCUS_MANAGER, ROLES.FOCUS_ADMIN];
             case ROLES.FOCUS_SUPER_ADMIN: return [ROLES.CUSTOMER_SUPPORT_SUPERVISOR,
                    ROLES.FOCUS_MANAGER, ROLES.FOCUS_ADMIN];
            default: return false;

        }
    }
    
    private static canUserPerformTask( task: any ) {
        return RoleUser.find( function(e: any) { return e === task ; } ) !== undefined ? true : false;
    }
    
    // private static canSuperUserPerformTask( task: any ) {
    //     return RoleSuperUser.find( function(e: any) { return e === task; } ) !== undefined ? true : false;
    // }
    
    private static canFocusManagerPerformTask( task: any ) {
        console.log('task', task);
        return RoleFocusManager.find( function(e: any) { return e === task; } ) !== undefined ? true : false;
    }

    // private static canCustomerSupportPerformTask( task: any ) {
    //     return RoleCustomerSupport.find( function(e: any) { return e === task; } ) !== undefined ? true : false;
    // }

    private static canCustomerSupportSurpervisorPerformTask( task: any ) {
        return RoleCustomerSupportSurpervisor.find( 
                    function(e: any) { return e === task; } ) !== undefined ? true : false;
    }

    private static canFocusAdminPerformTask( task: any ) {
        console.log('task', task);
        return RoleFocusAdmin.find( function(e: any) { return e === task; } ) !== undefined ? true : false;
    }
    private static canFocusSuperAdminPerformTask( task: any ) {
        console.log('task', task);
        return RoleFocusSuperAdmin.find( function(e: any) { return e === task; } ) !== undefined ? true : false;
    }
    private static canOrganizationAdminPerformTask( task: any ) {
        console.log('task', task);
        return RoleOrganizationAdmin.find( function(e: any) { return e === task; } ) !== undefined ? true : false;
    }

}


// WEBPACK FOOTER //
// ./src/components/common/auth.tsx